import script from "./PopupButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopupButton.vue?vue&type=script&setup=true&lang=ts"

import "./PopupButton.vue?vue&type=style&index=0&id=8338a436&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8338a436"]])

export default __exports__